import {
    FETCH_STATE_REQUEST,
    FETCH_STATE_SUCCESS,
    FETCH_STATE_FAILURE
  } from '../constants/stateConstants';
  
  const initialState = {
    states: [],
    loading: false,
    error: null
  };
  
  const stateReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_STATE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null
        };
      case FETCH_STATE_SUCCESS:
        return {
          ...state,
          loading: false,
          states: action.payload,
          error: null
        };
      case FETCH_STATE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      default:
        return state;
    }
  };
  
  export default stateReducer;
  